import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  'https://giggs-backend-ff5df60a245f.herokuapp.com/';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem('giggs_tokens');

    if (raw) {
      try {
        const tokens = JSON.parse(raw);

        const token =
          tokens.accessToken ||
          tokens.access_token ||
          tokens.token ||
          tokens.access ||
          null;

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch {
        // Ignore invalid JSON
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 401 = missing/expired token; 498 = backend's "token not found in DB".
const AUTH_FAILURE_STATUSES = [401, 498];

// These endpoints legitimately return 401 (e.g. wrong password) while the user
// is already on an auth screen — never redirect on those.
const AUTH_ENDPOINTS = ['/login', '/register', '/reset-password', '/renew-token'];
const isAuthEndpoint = (url = '') => AUTH_ENDPOINTS.some((p) => url.includes(p));

const hasStoredToken = () => {
  try {
    return !!localStorage.getItem('giggs_tokens');
  } catch {
    return false;
  }
};

// Clear the dead session and send the user to login. Full reload wipes all
// in-memory state; replace() keeps the back button from returning to the dead page.
const forceLogout = () => {
  try {
    localStorage.removeItem('giggs_user');
    localStorage.removeItem('giggs_tokens');
  } catch {
    // ignore
  }
  if (window.location.pathname !== '/login') {
    window.location.replace('/login?session=expired');
  }
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';

    // Only bounce users who *think* they're logged in (have a stored token)
    // but whose token was rejected — not anonymous visitors or failed logins.
    if (
      AUTH_FAILURE_STATUSES.includes(status) &&
      !isAuthEndpoint(url) &&
      hasStoredToken()
    ) {
      forceLogout();
    }

    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Something went wrong';

    return Promise.reject({
      ...error,
      message,
      status,
    });
  }
);

export default api;